module.exports = __webpack_public_path__ + "arrow.svg?e381e4bd9f3104972459cac7454fa89c";


//////////////////
// WEBPACK FOOTER
// ./assets/images/arrow.svg
// module id = 311
// module chunks = 0